import { defineStore } from 'pinia'
import CampaignService from '../service/CampaignService';
const campaignService = new CampaignService();
export const useCampaignsStore = defineStore({
    id: 'campaign',
    state: () => ({
        campaignList: null,
        singleCampaign: null,
        listFirmware: null,
        paginator_page: 1,
        paginator_size: 50,
        paginator_first: 0,
        sort_fields: 'creationTime',
        sort_order: -1
    }),
    getters: {
        getCampaignList(state) {
            return state.campaignList;
        },
        getSingleCampaign(state) {
            return state.singleCampaign;
        },
        getListFirmware(state) {
            return state.listFirmware;
        },
        getCampaignPaginatorPage: (state) => {
            return state.paginator_page;
        },
        getCampaignPaginatorSize: (state) => {
            return state.paginator_size;
        },
        getCampaignPaginatorFirst: (state) => {
            return state.paginator_first;
        },
        getCampaignSortObject: (state) => {
            return state.sort_object;
        },
        getCampaignSortFields: (state) => {
            return state.sort_fields;
        },
        getCampaignSortOrder: (state) => {
            return state.sort_order;
        }
    },
    actions: {
        setCampaignSortFields(sort_fields) {
            this.sort_fields = sort_fields;
        },
        setCampaignSortOrder(sort_order) {
            this.sort_order = sort_order;
        },
        setCampaignPaginatorPage(paginator_page) {
            this.paginator_page = paginator_page;
        },
        setCampaignPaginatorSize(paginator_size) {
            this.paginator_size = paginator_size;
        },
        setCampaignPaginatorFirst(paginator_first) {
            this.paginator_first = paginator_first;
        },
        setCampaignSortObject(sort_object) {
            this.sort_object = sort_object;
        },
        async createCampaignList() {
            this.campaignList = await campaignService.getCampaigns();
            return this.campaignList;
        },
        async getCSV(id) {
            let responseData = await campaignService.getCSV(id);
            return responseData;
        },
        async stopSingleCampaign(id) {
            return await campaignService.stopCampaign(id);
        },
        async deleteSingleCampaign(id) {
            return await campaignService.deleteCampaign(id);
        },
        async getCampaignById(id) {
            this.singleCampaign = await campaignService.getCampaignById(id);
            return this.singleCampaign;
        },
        async createListFirmware() {
            this.listFirmware = await campaignService.getListFirmware();
            return this.listFirmware;
        },
        async getGroupsForCampaign(data) {
            return await campaignService.getGoupForCampaign(data);
        },
        async getCampaignListNotNull() {
            return (this.getCampaignList === null) ? this.createCampaignList() : this.getCampaignList;
        },
        async createCampaign(data) {
            return await campaignService.createCampaign(data);
        },
        async modifySingleCampaign(payload) {
            this.singleCampaign = await campaignService.setSingleCampaign(payload);
            return this.singleCampaign;
        },
    }
})